export default __webpack_public_path__ + "img/8f0221d1890e607d09200134ea7e5508.svg";